import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { twilioRegistrationSummaryStatusSelector } from '../admin-selectors';

import * as Api from '../../api/api';

export const loadTwilioRegistrationSummary = () =>
  createGenericDispatcher({
    name: 'LOAD_TWILIO_REGISTRATION_SUMMARY',
    loadFunction: () => Api.get(`/twilio-trust-hub/registration-summary`),
    args: {},
    shouldExecuteSelector: twilioRegistrationSummaryStatusSelector,
  });
